export const setRestData = (data) => ({
    type: 'SET_REST_DATA',
    data
});